import React, { useState, useEffect, useRef } from "react";
import cloneDeep from "lodash/cloneDeep";
import {
  COHORTS_DISCUSSION_COMMENT_LIST_API,
  COHORTS_LIKE_POST_THREAD_API,
  COHORTS_POST_COMMENT_REMOVE_API,
  COHORTS_POST_COMMENT_REPLY_LIST_API,
  COHORTS_POST_COMMENT_REPLY_API,
} from "../constants/ApplicationUrl";
import api from "../dependencies/utils/Api";
import EmojiIcon from "../../../assets/svg/emojiIcon.svg";
import LikesIcon from "../../../assets/svg/likesIcon.svg";
import LikedIcon from "../../../assets/svg/likedIcon.svg";
import AttachIcon from "../../../assets/svg/attachment.svg";
import ReplyIcon from "../../../assets/svg/replyIcon.svg";
import DeleteIcon from "../../../assets/svg/deleteCohort.svg";
import EditButton from "../../../assets/svg/editButton.svg";
import profileIcon from "../../../assets/images/hashImage.jpeg";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

// import profileIcon from "../../../assets/svg/dashboard/profile-iconRound.svg";

import swal from "sweetalert";
import {
  cohortCommentReplyPost,
  cohortCommentReplyList,
} from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
function CommentsBox(props) {
  const {
    item,
    postAPI,
    discussionList,
    testIndex,
    viewStartupProfile,
    viewMentorProfile,
    reloadPage,
    timeDifference,
    commentLike,
    commentUnlike,
  } = props;
  const [fileData, setFileData] = useState();
  const [fileData2, setFileData2] = useState();
  const [fileData3, setFileData3] = useState();
  const [fileData4, setFileData4] = useState();
  const [commentsData, setCommentsData] = useState("");
  const [replyList, setReplyList] = useState("");
  const [replyListPaginate, setReplyListPaginate] = useState("");
  const [commentsPage, setCommentsPage] = useState(1);
  const [replyPage, setReplyPage] = useState(1);
  const [replyPressed, setReplyPressed] = useState(-1);
  const [replyCommentId, setReplyCommentId] = useState("");
  const [limitMax, setLimitMax] = useState(4);
  const [commentsPaginate, setCommentsPaginate] = useState("");
  const [inputFiled, setInputFiled] = useState("");
  const [replyField, setReplyField] = useState("");
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const textAreaRef = useRef(null);
  const [toggleEmoji, setToggleEmoji] = useState(false);
  const [textareaheight, setTextareaheight] = useState(1);
  const [editMode, setEditMode] = useState(false);
  const [editModeReply, setEditModeReply] = useState(-1);
  const [editData, setEditData] = useState("");
  const [editData2, setEditData2] = useState("");
  const [toggleMsg, setToggleMsg] = useState(false);
  const [input, setInput] = useState("");

  const onEmojiClick = (event, emojiObject) => {
    setChosenEmoji(emojiObject);
  };
  const clickonFileinput = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume");
    element.click();
  };
  const clickonFileinput2 = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume2");
    element.click();
  };
  const clickonFileinput3 = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume3");
    element.click();
  };
  const clickonFileinput4 = (event) => {
    event.preventDefault();
    let element = document.getElementById("fileUpload-resume4");
    element.click();
  };
  const handleInputChange = (e) => {
    setFileData((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
    const newFormData = {
      ...fileData,
      [e.target.name]: e.target.files[0],
    };
  };
  const handleInputChange2 = (e) => {
    setFileData2((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
  };
  const handleInputChange3 = (e) => {
    setFileData3((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
  };
  const handleInputChange4 = (e) => {
    setFileData4((user) => {
      return { ...user, [e.target.name]: e.target.files[0] };
    });
  };
  const removeFile = (fileType) => {
    if (fileType === "uploadResume") {
      setFileData((user) => {
        return { ...user, ["uploadResume"]: null };
      });
    }
  };
  const removeFile2 = (fileType) => {
    if (fileType === "uploadResume2") {
      setFileData2((user) => {
        return { ...user, ["uploadResume2"]: null };
      });
    }
  };
  const removeFile3 = (fileType) => {
    if (fileType === "uploadResume3") {
      setFileData3((user) => {
        return { ...user, ["uploadResume3"]: null };
      });
    }
  };
  const removeFile4 = (fileType) => {
    if (fileType === "uploadResume4") {
      setFileData4((user) => {
        return { ...user, ["uploadResume4"]: null };
      });
    }
  };
  const getList = (pageNum) => {
    if (cloneDeep(discussionList)[testIndex].commentsVisibility) {
      let params = {
        cohortId: item?.cohortId,
        postId: item?.postId,
        pageFilter: {
          currentPage: 0,
          includeCount: true,
          pageSize: pageNum !== 0 && pageNum > 0 ? pageNum * 5 : 5,
          sortField: "updatedDate",
          sortOrder: "DESC",
        },
      };
      api
        .POST(COHORTS_DISCUSSION_COMMENT_LIST_API, params)
        .then((res) => {
          setCommentsData(res.data.data);
          setCommentsPaginate(res.data.paginate);
        })
        .catch((err) => {});
      // getCommentsList(params)
    }
  };

  const postAComment = (event, mode, commentId) => {
    const formData = new FormData();
    let params;
    if (mode == "create") {
      params = {
        cohortId: item?.cohortId,
        postId: item?.postId,
        commentText: event.target?.value,
      };

      formData.append("commentData", JSON.stringify(params));
      formData.append("commentAttach", fileData?.uploadResume);
    } else {
      params = {
        cohortId: item?.cohortId,
        postId: item?.postId,
        commentText: event.target?.value,
        commentId: commentId,
      };

      formData.append("commentData", JSON.stringify(params));
      formData.append("commentAttach", fileData2?.uploadResume2);
      setEditMode(false);
    }

    postAPI(formData);
    removeFile("uploadResume");
    removeFile2("uploadResume2");
    setTimeout(() => {
      setShowEmojis(false);
      setShowEmojis2(false);
      setShowEmojis3(false);
      setShowEmojis4(false);
      setInput("");
      getList(commentsPage);
      setInputFiled("");
      setEditData("");
      setEditData2("");
      reloadPage(true);
      setTextareaheight(1);
      window.scrollTo(1500, 1500);
    }, 750);
  };

  const postAReply = (event, mode, commentId) => {
    setReplyField("");
    const formData2 = new FormData();
    let params;
    if (mode == "create") {
      params = {
        repliedTo: commentId,
        cohortId: item?.cohortId,
        postId: item?.postId,
        commentText: event.target?.value,
      };
      formData2.append("commentData", JSON.stringify(params));
      formData2.append("commentAttach", fileData3?.uploadResume3);
    } else {
      params = {
        cohortId: item?.cohortId,
        postId: item?.postId,
        commentText: event.target?.value,
        repliedTo: item?.commentId,
        commentId: commentId,
      };
      formData2.append("commentData", JSON.stringify(params));
      formData2.append("commentAttach", fileData4?.uploadResume4);
    }
    api
      .POST(COHORTS_POST_COMMENT_REPLY_API, formData2)
      .then((res) => {
        // setReplyList(res.data.data);
        // setReplyListPaginate(res.data.paginate);
      })
      .catch((err) => {});
    // cohortCommentReplyPost(formData2);
    setTimeout(() => {
      // viewReplyList(commentId, 1);
      if (mode == "edit") {
        setReplyPressed(-1);
      }
      setEditModeReply(-1);
      setEditData("");
      setEditData2("");
      setShowEmojis(false);
      setShowEmojis2(false);
      setShowEmojis3(false);
      setShowEmojis4(false);
      getList(commentsPage);
      removeFile3("uploadResume3");
      removeFile4("uploadResume4");
      viewReplyList(commentId, 1);
      setInputFiled("");
      reloadPage(true);
      setTextareaheight(1);
      window.scrollTo(1500, 1500);
    }, 750);
  };
  const postCommentLike = (postId, commentId, liked) => {
    let params = {
      cohortId: item?.cohortId,
      postId: postId,
      commentId: commentId,
      like: liked, // true for like and false for dislike
    };
    commentLike(params);
    setTimeout(() => {
      getList(commentsPage);
      reloadPage(true);
    }, 750);
  };
  const postCommentUnLike = (postId, commentId) => {
    let params = {
      cohortId: item?.cohortId,
      postId: postId,
      commentId: commentId,
    };
    commentUnlike(params);
    setTimeout(() => {
      getList(commentsPage);
      reloadPage(true);
    }, 750);
  };
  useEffect(() => {
    getList(commentsPage);
  }, [item]);

  const testDocumentPresent = (item2) => {
    if (
      item2?.commentAttach !== null &&
      item2?.commentAttach !== undefined &&
      item2?.commentAttach !== "" &&
      item2?.commentAttachType !== null &&
      item2?.commentAttachType !== "" &&
      item2?.commentAttachType.substring(0, 11) == "application"
    )
      return true;
    else return false;
  };
  const testImagePresent = (item2) => {
    if (
      item2?.commentAttach !== null &&
      item2?.commentAttach !== undefined &&
      item2?.commentAttach !== "" &&
      item2?.commentAttachType !== null &&
      item2?.commentAttachType !== "" &&
      item2?.commentAttachType.substring(0, 5) == "image"
    )
      return true;
    else return false;
  };
  const testVideoPresent = (item2) => {
    if (
      item2?.commentAttach !== null &&
      item2?.commentAttach !== undefined &&
      item2?.commentAttach !== "" &&
      item2?.commentAttachType !== null &&
      item2?.commentAttachType !== "" &&
      item2?.commentAttachType == "video/mp4"
    )
      return true;
    else return false;
  };
  useEffect(() => {
    if (commentsPage > 0) {
      getList(commentsPage);
    }
  }, [commentsPage]);
  useEffect(() => {
    if (replyPage > 0) {
      viewReplyList(replyCommentId, replyPage);
    }
  }, [replyPage]);
  const handleDelete = (postId, commentId) => {
    swal("Are you sure?", "Do you want to delete this comment?", {
      icon: "warning",
      buttons: {
        delete: {
          text: "OK",
        },
        decline: {
          text: "CANCEL",
        },
      },
    })
      .then((value) => {
        if (value === "delete") {
          setReplyPressed(-1);
          deleteapiCall(postId, commentId);
        } else {
          swal("Delete operation cancelled");
        }
      })

      .catch((err) => {});
  };

  const deleteapiCall = (postId, commentId) => {
    let params = {
      commentId: commentId,
      postId: postId,
      cohortId: item.cohortId,
    };
    api
      .POST(COHORTS_POST_COMMENT_REMOVE_API, params)
      .then((res) => {
        setTimeout(() => {
          reloadPage(true);
        }, 1000);
      })
      .catch((err) => {});
  };

  const viewReplyList = (commentId, pageNum) => {
    let params;
    params = {
      repliedTo: commentId,
      cohortId: item?.cohortId,
      postId: item?.postId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: pageNum !== 0 && pageNum > 0 ? pageNum * 5 : 5,
        sortField: "updatedDate",
        sortOrder: "DESC",
      },
    };
    api
      .POST(COHORTS_POST_COMMENT_REPLY_LIST_API, params)
      .then((res) => {
        setReplyList(res.data.data);
        setReplyListPaginate(res.data.paginate);
        // setCommentsData(res.data.data);
        // setCommentsPaginate(res.data.paginate);
      })
      .catch((err) => {});
    // cohortCommentReplyList(params);
  };
  const addEmoji = (e) => {
    let sym = e.unified.split("-");
    let codesArray = [];
    sym.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    setInput(input + emoji);
  };
  const addEmoji2 = (e) => {
    let sym = e.unified.split("-");
    let codesArray = [];
    sym.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    setEditData(editData + emoji);
  };
  const addEmoji3 = (e) => {
    let sym = e.unified.split("-");
    let codesArray = [];
    sym.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    setReplyField(replyField + emoji);
  };
  const addEmoji4 = (e) => {
    let sym = e.unified.split("-");
    let codesArray = [];
    sym.forEach((el) => codesArray.push("0x" + el));
    let emoji = String.fromCodePoint(...codesArray);
    setEditData2(editData2 + emoji);
  };
  const [showEmojis, setShowEmojis] = useState(false);
  const [showEmojis2, setShowEmojis2] = useState(false);
  const [showEmojis3, setShowEmojis3] = useState(false);
  const [showEmojis4, setShowEmojis4] = useState(false);
  const [showEmojis5, setShowEmojis5] = useState(false);

  return (
    <div>
      {cloneDeep(discussionList)[testIndex].commentsVisibility && (
        <div className="cohortDisussionCommentBox">
          <div
            className="d-flex"
            style={{
              padding: "15px",
              paddingLeft: "5px",
              paddingRight: "15px",
            }}
          >
            <div style={{ width: "0" }}>
              <img
               src={
                loggedIn?.image == null ||
                loggedIn?.image == "" ||
                loggedIn?.image == undefined
                  ? profileIcon
                  : loggedIn?.image
              }
              className={ loggedIn?.image == null ||
                loggedIn?.image == "" ||
                loggedIn?.image == undefined
                  ?"cohortMentorProfileIcon5":"cohortMentorProfileIcon2"}
              />
            </div>
            <div className="inputBoxDiscussion2">
              <textarea
                type="text"
                value={input}
                onChange={(e) => {
                  setInputFiled(e.target.value);
                  setInput(e.target.value);
                  const wordCounter = e.target.value?.length;
                  if (wordCounter > 61) {
                    let newCounter = Math.floor(wordCounter / 61);
                    setTextareaheight(newCounter + 1);
                  } else {
                    setTextareaheight(1);
                  }
                }}
                onKeyDown={(event) => {
                  if (event.keyCode == 13 && !event.shiftKey) {
                    event.preventDefault();
                    postAComment(event, "create", "");
                  }
                }}
                rows={textareaheight}
                ref={textAreaRef}
                className="discussionBoxInput2"
                name="myComments"
                placeholder="Add Comment"
              />
            </div>
            <div
              style={{ width: "0" }}
              // onClick={() => setToggleEmoji(!toggleEmoji)}
            >
              <img
                className="cohortMentorProfileIcon3"
                src={EmojiIcon}
                style={{ right: "5rem" }}
                onClick={() => {
                  setShowEmojis(!showEmojis);
                }}
              />
              {showEmojis && (
                <div style={{ position: "absolute" ,zIndex:"10000000"}}>
                  <Picker data={data} onEmojiSelect={addEmoji} />
                </div>
              )}
            </div>
            <div
              style={{ width: "0" }}
              // onClick={() => setToggleEmoji(!toggleEmoji)}
            >
              <img
                className="cohortMentorProfileIcon3"
                src={AttachIcon}
                onClick={clickonFileinput}
              />
              <div className="fileupload-resume-startup">
                <input
                  className="resume-upload"
                  type="file"
                  id="fileUpload-resume"
                  required
                  name="uploadResume"
                  onChange={handleInputChange}
                  accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx,.mp4"
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
          {fileData &&
            fileData !== undefined &&
            fileData?.uploadResume !== null && (
              <div style={{ marginBottom: "50px", marginLeft: "10px" }}>
                <div className="file-name" style={{ float: "left" }}>
                  {fileData?.uploadResume?.name?.length > 20
                    ? fileData?.uploadResume?.name.substring(0, 20) + "..."
                    : fileData?.uploadResume?.name}
                  <span
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    onClick={() => removeFile("uploadResume")}
                  >
                    {" "}
                    X{" "}
                  </span>
                </div>
              </div>
            )}
          {cloneDeep(commentsData) !== undefined &&
            cloneDeep(commentsData) !== null &&
            cloneDeep(commentsData) !== "" &&
            cloneDeep(commentsData)?.length > 0 &&
            cloneDeep(commentsData).map((item2, index2) => {
              return (
                <div>
                  {editMode !== index2 ? (
                    <>
                      <div className="cohortDiscussionPostHeader2">
                        <div className="d-flex " style={{ width: "95%" }}>
                          <div
                            onClick={() => {
                              if (item2?.commentedByRole == "Startup") {
                                viewStartupProfile(item2.commentedByDPIITNO);
                              } else {
                                viewMentorProfile(item2?.commentedBy);
                              }
                            }}
                          >
                            <img
                              className="cohortMentorProfileIcon"
                              // src={item2?.commentedByImage}
                              src={
                                item2?.commentedByImage == null ||
                                item2?.commentedByImage == "" ||
                                item2?.commentedByImage == undefined
                                  ? profileIcon
                                  : item2?.commentedByImage
                              }
                            />
                          </div>
                          <div className="d-flex cohortDiscussionPostUserBox">
                            <div className="d-flex flex-column">
                              <div className="d-flex">
                                <div
                                  className="d-flex cohortSessionContentItem"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    if (item2?.commentedByRole == "Startup") {
                                      viewStartupProfile(
                                        item2.commentedByDPIITNO
                                      );
                                    } else {
                                      viewMentorProfile(item2?.commentedBy);
                                    }
                                  }}
                                >
                                  {item2?.commentedByName}
                                </div>
                                <div className="cohortDiscussionUserRole">
                                  {item2?.commentedByRole == "Admin"
                                    ? "Maarg Admin"
                                    : item2?.commentedByRole}
                                </div>
                              </div>
                              {item2?.commentedByRole !== "Admin" && (
                                <div className="d-flex cohortSessionContentItem3">
                                  {item2?.commentedByDesignation}
                                  {" " + "of" + " "}
                                  {item2?.commentedByOrganization}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="funtionalCohortIcons">
                            {
                              // (loggedIn?.id == item2?.cohortAdminId ||
                              loggedIn?.id == item2?.commentedBy && (
                                <div>
                                  <img
                                    onClick={() => {
                                      setEditMode(index2);
                                      setEditModeReply(-1);
                                      setEditData(item2?.commentText);
                                    }}
                                    src={EditButton}
                                    style={{
                                      maxWidth: "1.25rem",
                                      cursor: "pointer",
                                    }}
                                  />
                                </div>
                              )
                            }
                            {(((loggedIn?.id == item?.cohortAdminId ||
                              loggedIn?.id == item2?.commentedBy) &&
                              item2?.commentedByRole !== "Admin") ||
                              loggedIn?.role == "Admin") && (
                              <div>
                                <img
                                  onClick={() => {
                                    handleDelete(
                                      item2?.postId,
                                      item2?.commentId
                                    );
                                  }}
                                  src={DeleteIcon}
                                  style={{
                                    maxWidth: "1.25rem",
                                    cursor: "pointer",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {item2.addedDate != undefined &&
                            item2.addedDate != null &&
                            item2.addedDate != "" && (
                              <div className="cohortDiscussionUserTime">
                                {timeDifference(item2.addedDate)}
                              </div>
                            )}
                        </div>
                      </div>
                      <div
                        className="cohortDiscussionPostHeader3 d-flex"
                        // style={{
                        //   paddingTop: "5px",
                        //   paddingBottom: "5px",
                        //   paddingLeft: "10px",
                        //   paddingRight: "2px",
                        // }}
                        style={
                          testDocumentPresent(item2) ||
                          testImagePresent(item2) ||
                          testVideoPresent(item2)
                            ? {
                                paddingTop: "5px",
                                paddingBottom: "5px",
                                paddingLeft: "10px",
                                paddingRight: "2px",
                                borderRadius: "0",
                              }
                            : {
                                paddingTop: "5px",
                                paddingBottom: "5px",
                                paddingLeft: "10px",
                                paddingRight: "2px",
                              }
                        }
                      >
                        {item2?.commentText}
                      </div>
                    </>
                  ) : (
                    <div
                      className="d-flex"
                      style={{
                        padding: "15px",
                        paddingLeft: "5px",
                        paddingRight: "15px",
                      }}
                    >
                      <div style={{ width: "0" }}>
                        <img
                         src={
                          loggedIn?.image == null ||
                          loggedIn?.image == "" ||
                          loggedIn?.image == undefined
                            ? profileIcon
                            : loggedIn?.image
                        }
                        className={ loggedIn?.image == null ||
                          loggedIn?.image == "" ||
                          loggedIn?.image == undefined
                            ?"cohortMentorProfileIcon5":"cohortMentorProfileIcon2"}
                          // className="cohortMentorProfileIcon2"
                          // src={loggedIn?.image}
                        />
                      </div>
                      <div
                        className="inputBoxDiscussion2"
                        style={{ width: "85%" }}
                      >
                        <textarea
                          type="text"
                          value={editData}
                          onChange={(e) => {
                            // setInputFiled(e.target.value);
                            setEditData(e.target.value);
                            const wordCounter = e.target.value?.length;
                            if (wordCounter > 78) {
                              let newCounter = Math.floor(wordCounter / 78);
                              setTextareaheight(newCounter + 1);
                            } else {
                              setTextareaheight(1);
                            }
                          }}
                          onKeyDown={(event) => {
                            if (event.keyCode == 13 && !event.shiftKey) {
                              event.preventDefault();
                              postAComment(event, "edit", item2?.commentId);
                            }
                          }}
                          rows={textareaheight}
                          ref={textAreaRef}
                          className="discussionBoxInput2"
                          name="myComments"
                          placeholder="Add Comment"
                        />
                      </div>
                      <div
                        style={{ width: "0" }}
                        // onClick={() => setToggleEmoji(!toggleEmoji)}
                      >
                        <img
                          className="cohortMentorProfileIcon3"
                          src={EmojiIcon}
                          style={{ right: "5rem" }}
                          onClick={() => {
                            setShowEmojis2(!showEmojis2);
                          }}
                        />
                        {showEmojis2 && (
                          <div style={{ position: "absolute" ,zIndex:"10000000" }}>
                            <Picker data={data} onEmojiSelect={addEmoji2} />
                          </div>
                        )}
                      </div>
                      <div
                        style={{ width: "0" }}
                        // onClick={() => setToggleEmoji(!toggleEmoji)}
                      >
                        <img
                          className="cohortMentorProfileIcon3"
                          src={AttachIcon}
                          onClick={clickonFileinput2}
                        />
                        <div className="fileupload-resume-startup">
                          <input
                            className="resume-upload"
                            type="file"
                            id="fileUpload-resume2"
                            required
                            name="uploadResume2"
                            onChange={handleInputChange2}
                            accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx,.mp4"
                            style={{ display: "none" }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                  {fileData2 && fileData2?.uploadResume2 !== null ? (
                    <div style={{ marginBottom: "50px", marginLeft: "10px" }}>
                      <div className="file-name" style={{ float: "left" }}>
                        {fileData2?.uploadResume2?.name?.length > 20
                          ? fileData2?.uploadResume2?.name.substring(0, 20) +
                            "..."
                          : fileData2?.uploadResume2?.name}
                        <span
                          style={{ marginLeft: "10px", cursor: "pointer" }}
                          onClick={() => removeFile2("uploadResume2")}
                        >
                          {" "}
                          X{" "}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {testImagePresent(item2) && (
                        <div>
                          <img
                            className="cohortDiscussionImage2"
                            src={item2?.commentAttach}
                          />
                        </div>
                      )}
                      {testDocumentPresent(item2) && (
                        <div className="cohortPdfBox2">
                          <div
                            className="fileName2"
                            onClick={() => {
                              window
                                .open(item2?.commentAttach, "_blank")
                                .focus();
                            }}
                          >
                            View Attachment
                          </div>
                        </div>
                      )}
                      {testVideoPresent(item2) && (
                        <div className="cohortPdfBox2">
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <>
                                {toggleMsg && (
                                  <div className="overlayText">
                                    <p className="topText">
                                      Please wait a few moments, video is
                                      loading ...
                                    </p>
                                  </div>
                                )}

                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                  className="statusiconsmodal newcompletediconsabove"
                                >
                                  <video
                                    id={"video"}
                                    width="100%"
                                    height="100%"
                                    controls
                                    preload="auto"
                                    autoplay="autoplay"
                                    onLoadedData={() => {
                                      setToggleMsg(false);
                                    }}
                                  >
                                    <source
                                      src={item2?.commentAttach}
                                      type="video/mp4"
                                    />
                                  </video>
                                </div>
                              </>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  <div className="d-flex">
                    <div className="cohortDiscussionLikeBox d-flex" style={{cursor:"pointer"}}  onClick={() => {
                          if (!item2?.liked)
                            postCommentLike(
                              item2?.postId,
                              item2?.commentId,
                              true
                            );
                          else
                            postCommentUnLike(item2?.postId, item2?.commentId);
                        }}>
                      <div
                       
                      >
                        <img
                          src={item2?.liked ? LikedIcon : LikesIcon}
                          style={{
                            minWidth: "0.8rem",
                            maxWidth: "1rem",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                      <div className="commentsLikeText">
                        {" "}
                        {item2?.likes !== undefined &&
                        item2?.likes !== false &&
                        item2?.likes !== null &&
                        item2?.likes > 0
                          ? item2?.likes
                          : ""}{" "}
                        Like
                      </div>
                    </div>
                    {/* <div className="cohortDiscussionLikeBox d-flex">
                      <div
                        onClick={() => {
                          // console.log("ITEM",item2)
                          if (!item2?.disliked)
                          postCommentLike(
                            item2?.postId,
                            item2?.commentId,
                            false
                          );
                        else
                          postCommentUnLike(item2?.postId, item2?.commentId);
                        }}
                      >
                        <img
                          src={item2?.disliked ? LikedIcon : LikesIcon}
                          style={{ maxWidth: "1rem", transform: "scaleY(-1)",cursor:"pointer" }}
                        />
                      </div>
                      <div className="commentsLikeText">{item2?.dislikes !== undefined && item2?.dislikes !== false && item2?.dislikes !== null && item2?.dislikes > 0 ? item2?.dislikes : ""}{" "}Dislike</div>
                    </div> */}
                    <div className="cohortDiscussionLikeBox d-flex" style={{cursor:"pointer"}}  onClick={() => {
                            if (replyPressed == index2) {
                              setReplyPressed(-1);
                            } else {
                              setReplyPressed(index2);
                              viewReplyList(item2.commentId, 1);
                              setReplyCommentId(item2.commentId);
                            }
                          }}>
                      <div>
                        <img
                          src={ReplyIcon}
                          style={{ maxWidth: "1rem", cursor: "pointer" }}
                         
                        />
                      </div>
                      <div className="commentsLikeText">
                        {item2?.totalReplies !== null &&
                        item2?.totalReplies !== undefined &&
                        item2?.totalReplies !== "" &&
                        item2?.totalReplies > 1
                          ? `${item2.totalReplies} Replies`
                          : item2?.totalReplies == 1
                          ? "1 Reply"
                          : "Reply"}
                      </div>
                    </div>
                  </div>
                  {replyPressed == index2 && (
                    <div>
                      {cloneDeep(replyList) !== undefined &&
                        cloneDeep(replyList) !== null &&
                        cloneDeep(replyList) !== "" &&
                        cloneDeep(replyList)?.length > 0 &&
                        cloneDeep(replyList).map((replyItem, index2) => {
                          return (
                            <>
                              {!(editModeReply == index2) ? (
                                <>
                                  <div
                                    className="cohortDiscussionPostHeader2"
                                    style={{ width: "70%", marginLeft: "6rem" }}
                                  >
                                    <div
                                      className="d-flex "
                                      style={{ width: "95%" }}
                                    >
                                      <div
                                        onClick={() => {
                                          if (
                                            replyItem?.commentedByRole == "Startup"
                                          ) {
                                            viewStartupProfile(
                                              replyItem.commentedByDPIITNO
                                            );
                                          } else {
                                            viewMentorProfile(
                                              replyItem?.commentedBy
                                            );
                                          }
                                        }}
                                      >
                                        <img
                                          className="cohortMentorProfileIcon"
                                          src={
                                            replyItem?.commentedByImage ==
                                              null ||
                                            replyItem?.commentedByImage == "" ||
                                            replyItem?.commentedByImage ==
                                              undefined
                                              ? profileIcon
                                              : replyItem?.commentedByImage
                                          }
                                          // src={replyItem?.commentedByImage}
                                        />
                                      </div>
                                      <div className="d-flex cohortDiscussionPostUserBox">
                                        <div className="d-flex flex-column">
                                          <div className="d-flex">
                                            <div
                                              className="d-flex cohortSessionContentItem"
                                              style={{ cursor: "pointer" }}
                                              onClick={() => {
                                                if (
                                                  replyItem?.commentedByRole ==
                                                  "Startup"
                                                ) {
                                                  viewStartupProfile(
                                                    replyItem.commentedByDPIITNO
                                                  );
                                                } else {
                                                  viewMentorProfile(
                                                    replyItem?.commentedBy
                                                  );
                                                }
                                              }}
                                            >
                                              {replyItem?.commentedByName}
                                            </div>
                                            <div className="cohortDiscussionUserRole">
                                              {replyItem?.commentedByRole ==
                                              "Admin"
                                                ? "Maarg Admin"
                                                : replyItem?.commentedByRole}
                                            </div>
                                          </div>
                                          {item2?.commentedByRole !==
                                            "Admin" && (
                                            <div className="d-flex cohortSessionContentItem3">
                                              {
                                                replyItem?.commentedByDesignation
                                              }
                                              {" " + "of" + " "}
                                              {
                                                replyItem?.commentedByOrganization
                                              }
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    <div>
                                      <div className="funtionalCohortIcons">
                                        {
                                          // (loggedIn?.id == item2?.cohortAdminId ||
                                          loggedIn?.id ==
                                            replyItem?.commentedBy && (
                                            <div>
                                              <img
                                                onClick={() => {
                                                  setEditModeReply(index2);
                                                  setEditMode(-1);
                                                  setEditData2(
                                                    replyItem?.commentText
                                                  );
                                                }}
                                                src={EditButton}
                                                style={{
                                                  maxWidth: "1.25rem",
                                                  cursor: "pointer",
                                                }}
                                              />
                                            </div>
                                          )
                                        }
                                        {(((loggedIn?.id ==
                                          item?.cohortAdminId ||
                                          loggedIn?.id ==
                                            replyItem?.commentedBy) &&
                                          replyItem?.commentedByRole !==
                                            "Admin") ||
                                          loggedIn?.role == "Admin") && (
                                          <div>
                                            <img
                                              onClick={() => {
                                                handleDelete(
                                                  replyItem?.postId,
                                                  replyItem?.commentId
                                                );
                                              }}
                                              src={DeleteIcon}
                                              style={{
                                                maxWidth: "1.25rem",
                                                cursor: "pointer",
                                              }}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      {replyItem.addedDate != undefined &&
                                        replyItem.addedDate != null &&
                                        replyItem.addedDate != "" && (
                                          <div className="cohortDiscussionUserTime">
                                            {timeDifference(
                                              replyItem.addedDate
                                            )}
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                  <div
                                    className="cohortDiscussionPostHeader3 d-flex"
                                    style={
                                      testDocumentPresent(replyItem) ||
                                      testImagePresent(replyItem) ||
                                      testVideoPresent(replyItem)
                                        ? {
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            paddingLeft: "10px",
                                            paddingRight: "2px",
                                            borderRadius: "0",
                                            width: "70%",
                                            marginLeft: "6rem",
                                          }
                                        : {
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            paddingLeft: "10px",
                                            paddingRight: "2px",
                                            width: "70%",
                                            marginLeft: "6rem",
                                          }
                                    }
                                  >
                                    {replyItem?.commentText}
                                  </div>
                                  {testImagePresent(replyItem) && (
                                    <div>
                                      <img
                                        className="cohortDiscussionImage2"
                                        src={replyItem?.commentAttach}
                                        style={{
                                          marginLeft: "6rem",
                                          width: "70%",
                                        }}
                                      />
                                    </div>
                                  )}
                                  {testDocumentPresent(replyItem) && (
                                    <div
                                      className="cohortPdfBox2"
                                      style={{
                                        marginLeft: "6rem",
                                        width: "70%",
                                      }}
                                    >
                                      <div
                                        className="fileName2"
                                        onClick={() => {
                                          window
                                            .open(
                                              replyItem?.commentAttach,
                                              "_blank"
                                            )
                                            .focus();
                                        }}
                                      >
                                        View Attachment
                                      </div>
                                    </div>
                                  )}

                                  {testVideoPresent(replyItem) && (
                                    <div
                                      className="cohortPdfBox2"
                                      style={{
                                        marginLeft: "6rem",
                                        width: "70%",
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                          width: "100%",
                                        }}
                                      >
                                        <div style={{ width: "100%" }}>
                                          <>
                                            {toggleMsg && (
                                              <div className="overlayText">
                                                <p className="topText">
                                                  Please wait a few moments,
                                                  video is loading ...
                                                </p>
                                              </div>
                                            )}

                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                              }}
                                              className="statusiconsmodal newcompletediconsabove"
                                            >
                                              <video
                                                id={"video"}
                                                width="100%"
                                                height="100%"
                                                controls
                                                preload="auto"
                                                autoplay="autoplay"
                                                onLoadedData={() => {
                                                  setToggleMsg(false);
                                                }}
                                              >
                                                <source
                                                  src={replyItem?.commentAttach}
                                                  type="video/mp4"
                                                />
                                              </video>
                                            </div>
                                          </>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  {replyList?.length - 1 == index2 &&
                                    index2 + 1 !==
                                      replyListPaginate?.totalElements && (
                                      <div
                                        className="d-flex sessionListMentor"
                                        style={{
                                          marginLeft: "6rem",
                                          fontWeight: "bold",
                                          marginTop: "0.75rem",
                                          marginBottom: "0.75rem",
                                          fontSize: "14px",
                                        }}
                                        onClick={() => {
                                          setReplyPage(replyPage + 1);
                                        }}
                                      >
                                        View More Replies
                                      </div>
                                    )}
                                </>
                              ) : (
                                <>
                                  <div
                                    className="replyCommentBox mt-2"
                                    style={{
                                      width: "74%",
                                      marginLeft: "5rem",
                                      marginBottom: "1rem",
                                    }}
                                  >
                                    <div
                                      className="d-flex"
                                      style={{
                                        // padding: "15px",
                                        paddingLeft: "5px",
                                        paddingRight: "15px",
                                      }}
                                    >
                                      <div style={{ width: "0" }}>
                                        <img
                                         src={
                                          loggedIn?.image == null ||
                                          loggedIn?.image == "" ||
                                          loggedIn?.image == undefined
                                            ? profileIcon
                                            : loggedIn?.image
                                        }
                                        className={ loggedIn?.image == null ||
                                          loggedIn?.image == "" ||
                                          loggedIn?.image == undefined
                                            ?"cohortMentorProfileIcon5":"cohortMentorProfileIcon2"}
                                          // className="cohortMentorProfileIcon2"
                                          // src={loggedIn?.image}
                                        />
                                      </div>
                                      <div className="inputBoxDiscussion2">
                                        <textarea
                                          type="text"
                                          value={editData2}
                                          onChange={(e) => {
                                            // setInputFiled(e.target.value);
                                            setEditData2(e.target.value);
                                            const wordCounter =
                                              e.target.value?.length;
                                            if (wordCounter > 78) {
                                              let newCounter = Math.floor(
                                                wordCounter / 78
                                              );
                                              setTextareaheight(newCounter + 1);
                                            } else {
                                              setTextareaheight(1);
                                            }
                                          }}
                                          onKeyDown={(event) => {
                                            if (
                                              event.keyCode == 13 &&
                                              !event.shiftKey
                                            ) {
                                              event.preventDefault();
                                              postAReply(
                                                event,
                                                "edit",
                                                replyItem?.commentId
                                              );
                                              // postAComment(event, "edit", replyItem?.commentId);
                                            }
                                          }}
                                          rows={textareaheight}
                                          ref={textAreaRef}
                                          className="discussionBoxInput2"
                                          name="myComments"
                                          placeholder="Add Comment"
                                        />
                                      </div>
                                      <div
                                        style={{ width: "0" }}
                                        // onClick={() => setToggleEmoji(!toggleEmoji)}
                                      >
                                        <img
                                          className="cohortMentorProfileIcon3"
                                          src={EmojiIcon}
                                          style={{ right: "5rem" }}
                                          onClick={() => {
                                            setShowEmojis3(!showEmojis3);
                                          }}
                                        />
                                        {showEmojis3 && (
                                          <div style={{ position: "absolute" ,zIndex:"10000000" }}>
                                            <Picker
                                              data={data}
                                              onEmojiSelect={addEmoji4}
                                            />
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        style={{ width: "0" }}
                                        // onClick={() => setToggleEmoji(!toggleEmoji)}
                                      >
                                        <img
                                          className="cohortMentorProfileIcon3"
                                          src={AttachIcon}
                                          onClick={clickonFileinput4}
                                        />
                                        <div className="fileupload-resume-startup">
                                          <input
                                            className="resume-upload4"
                                            type="file"
                                            id="fileUpload-resume4"
                                            required
                                            name="uploadResume4"
                                            onChange={handleInputChange4}
                                            accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx,.mp4"
                                            style={{ display: "none" }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        marginBottom: "50px",
                                        marginLeft: "10px",
                                      }}
                                    >
                                      {fileData4 &&
                                      fileData4?.uploadResume4 !== null ? (
                                        <div
                                          className="file-name"
                                          style={{ float: "left" }}
                                        >
                                          {fileData4?.uploadResume4?.name
                                            ?.length > 20
                                            ? fileData4?.uploadResume4?.name.substring(
                                                0,
                                                20
                                              ) + "..."
                                            : fileData4?.uploadResume4?.name}
                                          <span
                                            style={{
                                              marginLeft: "10px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              removeFile4("uploadResume4")
                                            }
                                          >
                                            {" "}
                                            X{" "}
                                          </span>
                                        </div>
                                      ) : (
                                        <>
                                          {testImagePresent(replyItem) && (
                                            <div>
                                              <img
                                                className="cohortDiscussionImage2"
                                                src={replyItem?.commentAttach}
                                              />
                                            </div>
                                          )}
                                          {testDocumentPresent(replyItem) && (
                                            <div className="cohortPdfBox2">
                                              <div
                                                className="fileName2"
                                                onClick={() => {
                                                  window
                                                    .open(
                                                      replyItem?.commentAttach,
                                                      "_blank"
                                                    )
                                                    .focus();
                                                }}
                                              >
                                                View Attachment
                                              </div>
                                            </div>
                                          )}

                                          {testVideoPresent(replyItem) && (
                                            <div
                                              className="cohortPdfBox2"
                                              style={{
                                                // marginLeft: "6rem",
                                                width: "94%",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  width: "100%",
                                                }}
                                              >
                                                <div style={{ width: "100%" }}>
                                                  <>
                                                    {toggleMsg && (
                                                      <div className="overlayText">
                                                        <p className="topText">
                                                          Please wait a few
                                                          moments, video is
                                                          loading ...
                                                        </p>
                                                      </div>
                                                    )}

                                                    <div
                                                      style={{
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                      }}
                                                      className="statusiconsmodal newcompletediconsabove"
                                                    >
                                                      <video
                                                        id={"video"}
                                                        width="100%"
                                                        height="100%"
                                                        controls
                                                        preload="auto"
                                                        autoplay="autoplay"
                                                        onLoadedData={() => {
                                                          setToggleMsg(false);
                                                        }}
                                                      >
                                                        <source
                                                          src={
                                                            replyItem?.commentAttach
                                                          }
                                                          type="video/mp4"
                                                        />
                                                      </video>
                                                    </div>
                                                  </>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </>
                              )}
                            </>
                          );
                        })}

                      <div
                        className="replyCommentBox mt-2"
                        style={{
                          width: "74%",
                          marginLeft: "5rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <div
                          className="d-flex"
                          style={{
                            // padding: "15px",
                            paddingLeft: "5px",
                            paddingRight: "15px",
                          }}
                        >
                          <div style={{ width: "0" }}>
                            <img
                              // className="cohortMentorProfileIcon2"
                              // src={loggedIn?.image}
                              src={
                                loggedIn?.image == null ||
                                loggedIn?.image == "" ||
                                loggedIn?.image == undefined
                                  ? profileIcon
                                  : loggedIn?.image
                              }
                              className={ loggedIn?.image == null ||
                                loggedIn?.image == "" ||
                                loggedIn?.image == undefined
                                  ?"cohortMentorProfileIcon5":"cohortMentorProfileIcon2"}
                            />
                          </div>
                          <div className="inputBoxDiscussion2">
                            <textarea
                              type="text"
                              value={replyField}
                              onChange={(e) => {
                                setReplyField(e.target.value);
                                const wordCounter = e.target.value?.length;
                                if (wordCounter > 50) {
                                  let newCounter = Math.floor(wordCounter / 50);
                                  setTextareaheight(newCounter + 1);
                                } else {
                                  setTextareaheight(1);
                                }
                              }}
                              onKeyDown={(event) => {
                                if (event.keyCode == 13 && !event.shiftKey) {
                                  event.preventDefault();
                                  postAReply(event, "create", item2?.commentId);
                                  // postAComment(event, "create", "");
                                }
                              }}
                              rows={textareaheight}
                              ref={textAreaRef}
                              className="discussionBoxInput2"
                              name="myComments"
                              placeholder="Add Reply"
                            />
                          </div>
                          <div
                            style={{ width: "0" }}
                            // onClick={() => setToggleEmoji(!toggleEmoji)}
                          >
                            <img
                              className="cohortMentorProfileIcon3"
                              src={EmojiIcon}
                              style={{ right: "5rem" }}
                              onClick={() => {
                                setShowEmojis4(!showEmojis4);
                              }}
                            />
                            {showEmojis4 && (
                              <div style={{ position: "absolute" ,zIndex:"10000000" }}>
                                <Picker data={data} onEmojiSelect={addEmoji3} />
                              </div>
                            )}
                          </div>
                          <div
                            style={{ width: "0" }}
                            // onClick={() => setToggleEmoji(!toggleEmoji)}
                          >
                            <img
                              className="cohortMentorProfileIcon3"
                              src={AttachIcon}
                              onClick={clickonFileinput3}
                            />
                            <div className="fileupload-resume-startup">
                              <input
                                className="resume-upload3"
                                type="file"
                                id="fileUpload-resume3"
                                required
                                name="uploadResume3"
                                onChange={handleInputChange3}
                                accept=".jpg, .jpeg, .png,.xls,.pdf,.xlsx,.docx,.mp4"
                                style={{ display: "none" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{ marginBottom: "50px", marginLeft: "10px" }}
                        >
                          {fileData3 && fileData3?.uploadResume3 !== null && (
                            <div
                              className="file-name"
                              style={{ float: "left" }}
                            >
                              {fileData3?.uploadResume3?.name?.length > 20
                                ? fileData3?.uploadResume3?.name.substring(
                                    0,
                                    20
                                  ) + "..."
                                : fileData3?.uploadResume3?.name}
                              <span
                                style={{
                                  marginLeft: "10px",
                                  cursor: "pointer",
                                }}
                                onClick={() => removeFile3("uploadResume3")}
                              >
                                {" "}
                                X{" "}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {commentsData?.length - 1 == index2 &&
                    index2 + 1 !== commentsPaginate?.totalElements && (
                      <div
                        className="d-flex sessionListMentor"
                        style={{ marginLeft: "1rem", fontWeight: "bold" }}
                        onClick={() => {
                          setCommentsPage(commentsPage + 1);
                        }}
                      >
                        View More Comments
                      </div>
                    )}
                </div>
              );
            })}
        </div>
      )}
    </div>
  );
}

export default CommentsBox;
